/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import Backgrid from 'backgrid';

import FileLinkView from '@/views/FileLinkView';

const FileLinkCell = Backgrid.Cell.extend({
  className: 'file-download-cell',

  initialize({ column, model }) {
    this.column = column;

    if (column.get('renderable')) {
      this.$el.addClass('renderable');
    }

    this.fileLinkView = new FileLinkView({
      el: this.$el,
      model: new Backbone.Model(model.get(column.get('name')))
    });
  },

  render() {
    const cellVal = this.model.get(this.column.get('name'));

    if (!cellVal.attachmentId) {
      this.$el.empty().append('--');
      return this;
    }

    this.fileLinkView.render();
    return this;
  }
});

export default FileLinkCell;
